/**
 * @file 登录库
 * @refs https://cooper.didichuxing.com/knowledge/share/page/rRAPXxMTN4cv
 * @usage Login.login().then(...)
 */
import DiDiLogin from '@didi/login'
import Cookie from 'js-cookie'
import {
  setStore,
  getStore,
  deleteStore,
} from '@/store/store-standard'

interface LoginData {
  ticket: string
  [key: string]: string
}

let cached = false
export const Login = {
  init() {
    if (cached) {
      return this
    }
    DiDiLogin.setConfig({
      appid: 200112,
      role: 1,
      lang: 'es-MX',
      country_calling_code: '+52',
      country_id: 484,
      canonical_country_code: 'MX',
      law_url:
        'https://page.didiglobal.com/global/silver-bullet-online/o4yjRt6a6vTA8crQ4aZCM?campaign_id=101120221020001&trace_id=&lang=es-MX',
    })
    cached = true
    return this
  },

  /**
   * 登录页面
   */
  async login() {
    this.init()
    const data = (await this._forceLogin()) as LoginData
    await this._after(data as LoginData)
    return data
  },

  /**
   * 手机号登录
   */
  async checkPhone(phone: string) {
    this.init()
    let data
    const response = await this._isLogin()
    if (
      response &&
      response.login &&
      response.cell === phone
    ) {
      data = response as LoginData
    } else {
      data = (await this._byPhone(phone)) as LoginData
    }
    await this._after(data as LoginData)
    return data
  },

  async logout() {
    if (!Cookie.get('token')) {
      return
    }
    deleteStore('user')
    Cookie.remove('token')
    return await this._logout()
  },

  /**
   * 登录成功后
   * @private
   */
  async _after(data: LoginData) {
    setStore('user', data)
    this.setTicket(data.ticket)
  },

  /**
   * 设置ticket
   */
  setTicket(ticket?: string) {
    // 没传ticket尝试从cookie中获取
    if (!ticket) {
      ticket = Cookie.get('ticket')
    }
    // 如果ticket存在值，则给passport设置
    if (ticket) {
      DiDiLogin.setTicket(ticket)
    }
    // 二次检查
    if (!ticket) {
      return
    }
    // 种cookie
    let domain = '.didiglobal.com' as string | undefined
    if (window.__INIT_STATE__.env === 'local') {
      domain = void 0
    }
    Cookie.set('token', ticket, {
      domain,
    })
  },
  /**
   * 获取ticket
   */
  getTicket() {
    // 尝试从内存中获取
    const ticketFromMemory = getStore('user')?.ticket
    if (ticketFromMemory) {
      return ticketFromMemory
    }
    // 先尝试从cookie中获取
    const ticketFromCookie = Cookie.get('token')
    if (ticketFromCookie) {
      return ticketFromCookie
    }
    // 再尝试从localStorage获取（passport植入）
    // 必须是同域名才有效
    try {
      const ticketFromLs = localStorage.getItem(
        'didih5_trinity_login_ticket'
      )
      if (ticketFromLs) {
        return ticketFromLs.replace(/"/g, '')
      }
    } catch (e) {
      console.log('Get ticket fail.', e)
    }
    return ''
  },
  /**
   * Is login
   * @private
   */
  _isLogin(): Promise<Record<string, unknown>> {
    return new Promise((resolve, reject) =>
      DiDiLogin.isLogin(resolve, reject)
    )
  },

  /**
   * 强登，当流程为KYC时，强登
   * @private
   */
  _forceLogin() {
    return new Promise((resolve, reject) =>
      DiDiLogin.forceLogin(resolve, reject)
    )
  },

  /**
   * Log in by phone number
   * @private
   */
  _byPhone(phone: string) {
    return new Promise((resolve, reject) =>
      DiDiLogin.checkPhone(phone, resolve, reject)
    )
  },

  /**
   * Log out
   * @private
   */
  _logout() {
    this.init()
    return new Promise((resolve, reject) =>
      DiDiLogin.logout(resolve, reject)
    )
  },
}
